module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/cn.json
// module id = VLSL
// module chunks = 1